import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Box, Stack, TableRow, TableCell, Typography, IconButton } from '@mui/material';

import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

import Label from 'src/components/label';
import Iconify from 'src/components/iconify';

StatusTableRow.propTypes = {
  row: PropTypes.object,
  handleDetailsClick: PropTypes.func,
  setSelected: PropTypes.func,
  handleOpenMenu: PropTypes.func,
};

export default function StatusTableRow({
  row,
  handleDetailsClick,
  setSelected,
  handleOpenMenu,
}) {
  const {
    statusId,
    statusColor,
    name,
    color,
    correspondences,
    description,
    department,
    systemMappedStatus,
    departmentId,
  } = row;
  const { t } = useTranslation();
  const { isSmallScreen } = useResponsiveScreen();
  const { statusDescription } = useMemo(() => {
    const statusDescription =
      statusId <= 5 ? t(`statusDescription.${systemMappedStatus}`) : description;
    return { statusDescription };
  }, [description, systemMappedStatus, statusId, t]);

  return (
    <TableRow hover sx={{ cursor: 'pointer' }} onClick={() => handleDetailsClick(row)}>
      <TableCell component="th" scope="row">
        <Stack alignItems="center">
          <Label
            color={color}
            sx={{
              fontSize: isSmallScreen && '0.55rem',
            }}
          >
            {name}
          </Label>
        </Stack>
      </TableCell>
      <TableCell align="left">
        <Typography
          variant="body2"
          sx={{
            fontSize: isSmallScreen && '0.65rem',
          }}
        >
          {statusDescription}
        </Typography>
      </TableCell>
      <TableCell
        align="left"
        sx={{
          fontSize: isSmallScreen && '0.65rem',
        }}
      >
        {t(`status.${systemMappedStatus}`)}
      </TableCell>
      <TableCell
        align="left"
        sx={{
          fontSize: isSmallScreen && '0.65rem',
        }}
      >
        {statusId <= 5
          ? t('pages.statusPage.globalStatus')
          : departmentId === 0
          ? t('pages.statusPage.noDepartment')
          : department}
      </TableCell>
      <TableCell align="left">
        <Stack alignItems="center" justifyContent="center">
          <Box
            height={isSmallScreen ? 20 : 25}
            width={isSmallScreen ? 20 : 25}
            bgcolor={statusId <= 6 ? statusColor : color}
            borderRadius={1}
          />
        </Stack>
      </TableCell>
      <TableCell align="left">
        {statusId > 5 && (
          <Stack
            alignItems="center"
            sx={{
              fontSize: isSmallScreen && '0.65rem',
            }}
          >
            {correspondences.length}
          </Stack>
        )}
      </TableCell>
      <TableCell
        align="center"
        sx={{
          position: 'sticky',
          zIndex: '100',
          right: 0,
          backgroundColor: 'white',
        }}
      >
        {statusId > 5 && (
          <IconButton
            size={isSmallScreen ? 'small' : 'large'}
            color="inherit"
            onClick={(event) => {
              event.stopPropagation();
              handleOpenMenu(event, row);
              setSelected(row);
            }}
          >
            <Iconify
              icon="eva:more-vertical-fill"
              sx={{
                width: 20,
                height: isSmallScreen ? 16 : 20,
              }}
            />
          </IconButton>
        )}
      </TableCell>
    </TableRow>
  );
}
